(function ($) {

    /*******************************/
    /*   STATIC PLUGIN VARIABLES   */
    /*******************************/

    var plugin = {
        idPropName: 'notification-id',
        idCounter: 0,
        pool: [],
        defaults: {
            type: 'default',                                        // Notification type ("default", "info", "warn", "error")
            id: null,                                               // Notification ID
            title: 'Notification',                                  // Title
            message: 'You were notified!',                          // Message
            elements: {                                             // Element types
                notification: 'div',                                // Tag name of base element
                message: 'div',                                     // Tag name of message element
            },
            classes: {                                              // Element classes
                notification: 'notification',                       // Class for base element
                message: 'notification-message',                    // Class for message element
                animating: 'notification-animating',                // Class set at base element when notification is animated
                open: 'notification-open',                          // Class for open notification
                closed: 'notification-closed',                      // Class for closed notification
                info: 'info',                                       // Class for informational notification
                warn: 'warn',                                       // Class for warning notification
                error: 'error'                                      // Class for error notification
            },
            animation: {                                            // Properties for open/close animation
                type: 'slide',                                      // Animation type, possible types are currently 'slide' (down on open, up on close) and null (no animation)
                easing: 'swing',                                    // jQuery easing type ('linear' or 'swing')
                speed: 300                                          // Animation duration
            },
            events: {
                open: null,                                         // Callback function when notification opened
                close: null                                         // Callback function when notification closed
            },
            closeOnOutsideClick: false,                             // Close options on click outside the list
            // closeImgSrc: '/images/times-solid.svg',                           // Image source for close button
            closeImgSrc: 'fa-sharp fa-solid fa-xmark',                           // Image source for close button
            closeImgAlt: 'Close Notification',                      // Image alt for close button
            infoImgSrc: '/line-awesome/svg/info-circle-solid.svg',                             // Image source for info icon
            infoImgAlt: 'Information',                              // Image alt for info icon
            warnImgSrc: '/line-awesome/svg/exclamation-triangle-solid.svg',                             // Image source for warning icon
            warnImgAlt: 'Warning',                                  // Image alt for warning icon
            errorImgSrc: 'fa-solid fa-poo',                           // Image source for warning icon
            errorImgAlt: 'Error',                                   // Image alt for warning icon
            autoOpen: 0,                                            // Determine the time after which the notification should be opend or false if ith should not be opened
            autoClose: false,                                       // Timeout for automatic closing
            removeOthers: false                                     // Remove already opened notifications on open
        }
    };


    /********************/
    /*   PLUGIN CLASS   */
    /********************/

    var Notification = function (e, options) {
        var self = this;


        /*************************/
        /*   PLUGIN ATTRIBUTES   */
        /*************************/

        self.e = e;
        self.id = ++plugin.idCounter;
        self.events = {
            open: [],
            close: []
        };
        self.options = $.extend(true, {}, plugin.defaults, options);


        /*********************/
        /*   PLUGIN SCRIPT   */
        /*********************/

        // Add instance to pool
        plugin.pool[self.id] = this;

        // Add callbacks to events
        $.each(self.events, function (name, list) {
            if (typeof self.options.events[name] === 'function')
                list.push(self.options.events[name]);
        });

        self.init();

        if (self.options.autoOpen !== false) setTimeout(function () {
            self.show();
        }, self.autoOpen);
    };


    /******************************/
    /*   PLUGIN CLASS PROTOTYPE   */
    /******************************/

    Notification.prototype = {
        init: function () {
            var self = this;

            self.views = {
                notification: self.createElement('notification', { id: self.options.id })
                    .addClass(self.options.classes.closed)
                    .addClass(self.options.classes[self.options.type])
                    .hide().css('height', 0).data(plugin.idPropName, self.id),
                message: self.createElement('message')
                    .html(self.options.message),
                closeButton: self.createElement('i', { 'class': self.options.closeImgSrc, alt: self.options.closeImgAlt }),
                icon: self.createElement('i', { 'class': self.options[self.options.type + 'ImgSrc'], alt: self.options[self.options.type + 'ImgAlt'] })
            };


            /*****************/
            /*   LISTENERS   */
            /*****************/

            self.views.closeButton.click(function () {
                self.toggle();
            });

            if (self.options.closeOnOutsideClick) {
                $(window).click(function () {
                    if (self.isOpen()) self.hide();
                });

                self.views.notification.click(function (event) {
                    event.stopPropagation();
                });
            }


            /**************/
            /*   OUTPUT   */
            /**************/

            self.hide();
            self.e.append(self.views.notification
                .append(self.views.message).append(self.views.closeButton));
        },
        createElement: function (type, properties) {
            var tag = typeof this.options.elements[type] !== 'undefined' ? this.options.elements[type] : type;

            return $('<' + tag + '/>', $.extend(properties, {
                'class': this.options.classes[type]
            }));
        },
        show: function () {
            var self = this;

            if (self.options.removeOthers) {
                self.e.find('.' + self.options.classes.notification).each(function () {
                    $.notification($(this)).hide();
                });
            }

            self.toggle(true);
            if (self.options.autoClose !== false) setTimeout(function () {
                self.hide();
            }, self.options.autoClose);
        },
        hide: function () {
            this.toggle(false);
        },
        toggle: function (visible) {
            var self = this, height = 0, setHeight = function () {
                self.views.notification.css('height', height);
                self.views.notification.removeClass(self.options.classes.animating);
                if (!visible) self.views.notification.remove();
            };

            visible = typeof visible !== 'undefined' ? visible : !self.isOpen();

            if (visible === self.isOpen()) return;
            if (visible) {
                height = 'auto';
                self.trigger('open', this);
                self.views.notification.show();
            } else self.trigger('close', this);

            self.views.notification
                    .toggleClass(self.options.classes.open, visible)
                    .toggleClass(self.options.classes.closed, !visible);

            switch (self.options.animation.type) {
            case 'slide':
                self.views.notification.addClass(self.options.classes.animating);
                self.views.notification.stop().animate({
                    height: height === 'auto' ? self.views.notification.get(0).scrollHeight : height
                }, self.options.animation.duration, self.options.animation.easing, setHeight);
                break;
            default:
                setHeight(height);
            }
        },
        isOpen: function () {
            return this.views.notification.is(':visible') && this.views.notification.hasClass(this.options.classes.open);
        },
        trigger: function (eventName, data) {
            data.event = eventName;
            data.name = this.options.name;
            data.id = this.id;
            $.each(this.events[eventName], function () {
                this($.extend({}, data));
            });
        },
        on: function (eventName, callback) {
            if (this.events[eventName] && typeof callback === 'function') {
                this.events[eventName].push(callback);
            }
        },
        open: function (callback) {
            this.on('open', callback);
        },
        close: function (callback) {
            this.on('close', callback);
        }
    };


    /*********************/
    /*   jQuery PLUGIN   */
    /*********************/

    $.notification = function (id) {
        if (typeof id === 'string' || id instanceof String)
            id = $(id);
        if (id instanceof jQuery)
            return plugin.pool[id.data(plugin.idPropName)];
        return plugin.pool[id];
    };

    $.fn.notification = function (options) {
        var e = $(this), id = e.data(plugin.idPropName);

        switch (typeof options) {
        case 'undefined':
            if (typeof id !== 'undefined') return $.notification(id);
        case 'object':
            e.each(function () {
                new Notification($(this), options);
            });
            return e;
        default:
            console.error('Invalid parameter: ' + options);
        }
    }
}(jQuery));
